import { useState } from "react";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import AlertBox from "../../components/AlertBox";
import { useOltListHooks } from "../../utils/infrastructure/OltUtils";
import Pagination from "../../components/Pagination";
import ModalCreateOlt from "../../components/infrastrucure/olt/ModalCreateOlt";
import ModalUpdateOlt from "../../components/infrastrucure/olt/ModalUpdateOlt";
import ModalViewOlt from "../../components/infrastrucure/olt/ModalViewOlt";
import ModalDeleteOlt from "../../components/infrastrucure/olt/ModalDeleteOlt";
import { useControlPermission } from "../../utils/ActionPermissionUtils";
import ModalViewUnconfig from "../../components/infrastrucure/olt/ModalViewUnconfig";
import { Link } from "react-router-dom";

export default function ManageOltPage() {
  let { hasAccess } = useControlPermission();
  let [alert, setAlert] = useState({ show: false, message: "", type: "" });

  let [formFilter, setFormFilter] = useState({ q: "" });
  let [filter, setFilter] = useState({ q: "", page: 1, page_size: 10 });

  let [selectedId, setSelectedId] = useState("");
  let [modal, setModal] = useState("");
  // create, update, delete

  const { data: oltData, meta, loading, errorMsg } = useOltListHooks({ filter });

  const applyFilter = () => {
    let form_filter = { ...filter, ...formFilter, page: 1 };
    setFilter(form_filter);
  };

  const resetFilter = () => {
    setFormFilter({ q: "" });
    setFilter({ q: "", page: 1, page_size: 10 });
  };

  const onSuccess = (message) => {
    setAlert({ show: true, message, type: "success" });
    setFilter({ ...filter });
  };

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  return (
    <MainLayout resource_key="setup-modem">
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">Manajemen OLT</h1>
          </div>
          <div className="col-auto">
            {hasAccess("create-olt") && (
              <button className="btn btn-primary" onClick={() => setModal("create")}>
                <i className="fa fa-plus"></i> Tambah OLT Baru
              </button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Box title={`Daftar OLT`} loading={loading}>
              <div className="row">
                <div className="col-lg-2 col-12">
                  <div className="form-group">
                    <label>Pencarian</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="nama / ip / deskripsi ..."
                      value={formFilter.q}
                      onChange={(event) => setFormFilter({ ...formFilter, q: event.target.value })}
                    />
                  </div>
                </div>
                <div className="col-auto">
                  <button
                    className="btn btn-primary"
                    onClick={() => applyFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Filter
                  </button>
                  <button
                    className="btn btn-default"
                    onClick={() => resetFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Reset
                  </button>
                </div>
              </div>
              {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
              <AlertBox {...alert} setAlert={setAlert} />
              <div className="auto-horizontal-scroll">
                <table className="table table-hover table-bordered table-striped">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Nama</th>
                      <th>Merk</th>
                      <th>Tipe</th>
                      <th>IP</th>
                      <th>Port</th>
                      <th>Deskripsi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {oltData.length === 0 && (
                      <tr>
                        <td colSpan={7} className="text-center">
                          Tidak ada data
                        </td>
                      </tr>
                    )}
                    {oltData.map((olt) => (
                      <tr key={olt.id}>
                        <td style={{ width: "140px" }}>
                          <div style={{ display: "flex", gap: "4px", marginBottom: "4px" }}>
                            {hasAccess("view-olt") && (
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => {
                                  setModal("view");
                                  setSelectedId(olt.id);
                                }}
                              >
                                <i className="fa fa-eye"></i> <div className="sr-only">Detail</div>
                              </button>
                            )}
                            {hasAccess("update-olt") && (
                              <button
                                className="btn btn-sm btn-info"
                                onClick={() => {
                                  setModal("update");
                                  setSelectedId(olt.id);
                                }}
                              >
                                <i className="fa fa-pencil"></i>
                                <div className="sr-only">Edit</div>
                              </button>
                            )}
                            {hasAccess("delete-olt") && (
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                  setModal("delete");
                                  setSelectedId(olt.id);
                                }}
                              >
                                <i className="fa fa-trash"></i>
                                <div className="sr-only">Delete</div>
                              </button>
                            )}
                          </div>
                          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                            {hasAccess("view-olt") && (
                              <Link
                                to={`/setup-modem/olt/${olt.id}/slot`}
                                className="btn btn-sm btn-custom-orange text-nowrap"
                              >
                                <i className="fa fa-check-to-slot"></i> OLT Slot
                              </Link>
                            )}
                            {hasAccess("view-olt") && (
                              <button
                                className="btn btn-sm btn-custom-purple text-nowrap"
                                onClick={() => {
                                  setModal("unconfig");
                                  setSelectedId(olt.id);
                                }}
                              >
                                <i className="fa fa-gears"></i> List Unconfig
                              </button>
                            )}
                          </div>
                        </td>
                        <td>{olt.name}</td>
                        <td>{olt.brand}</td>
                        <td>{olt.type}</td>
                        <td>{olt.ip}</td>
                        <td>{olt.port}</td>
                        <td>{olt.description || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {meta.count > meta.page_size && (
                <Pagination
                  totalpage={Math.ceil(meta.count / meta.page_size)}
                  selectedpage={meta.page}
                  clickpage={(page) => gotoPage(page)}
                  next={() => gotoPage(meta.page + 1)}
                  prev={() => gotoPage(meta.page - 1)}
                />
              )}
            </Box>
          </div>
        </div>
      </div>

      <ModalCreateOlt
        show={modal === "create"}
        onClose={() => setModal("")}
        onSuccess={onSuccess}
      />

      <ModalUpdateOlt
        show={modal === "update"}
        id={selectedId}
        onClose={() => setModal("")}
        onSuccess={onSuccess}
      />

      <ModalDeleteOlt
        show={modal === "delete"}
        id={selectedId}
        onClose={() => setModal("")}
        onSuccess={onSuccess}
      />

      <ModalViewOlt show={modal === "view"} id={selectedId} onClose={() => setModal("")} />
      <ModalViewUnconfig show={modal === "unconfig"} id={selectedId} onClose={() => setModal("")} />
    </MainLayout>
  );
}
